import styled, { css } from 'styled-components';
import { Box } from '@scope/scope-one-ui/core';
import { COLORS, SIZES } from '@scope/scope-one-ui/theme';
import ChevronLeft from 'assets/icons/chevron-left.svg';
import { pxToRem } from '@scope/scope-one-ui/global/utils';
import { SidebarWrapperProps, SideButtonProps } from './EventSidebar.d';

const iframeWidth = pxToRem(397);

export const IframeWindow = styled.iframe`
  border: 0;
  width: ${iframeWidth};
  height: 100vh;
  box-shadow: 0px 3px 65px #00000029;
`;

export const SidebarWrapper = styled(Box)<SidebarWrapperProps>(
  ({ open }) => css`
    position: fixed;
    top: 0;
    right: 0;
    z-index: 120;
    transform: ${!open && `translateX(calc(100% - ${SIZES.spacing(8)}))`};
    transition: 0.3s ease-out;
    pointer-events: none;

    > * {
      pointer-events: all;
    }
  `,
);

export const SideButton = styled.button<SideButtonProps>(
  ({ variant = 'primary', disabled }) => css`
    border: 0;
    outline: 0;
    height: ${SIZES.spacing(17)};
    width: ${SIZES.spacing(6)};
    cursor: pointer;
    border-radius: ${SIZES.spacing(2)} 0 0 ${SIZES.spacing(2)};
    transition: 0.3s ease-out;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    z-index: 1;

    ${variant === 'primary' &&
    css`
      background-color: ${COLORS.primary.main};
      color: ${COLORS.primary.text};

      :hover {
        background-color: ${COLORS.primary.hover};
        color: ${COLORS.primary.text};
      }
    `}

    ${variant === 'secondary' &&
    css`
      background-color: ${COLORS.secondary.hover};
      color: ${COLORS.secondary.text};

      :hover {
        background-color: ${COLORS.primary.main};
        color: ${COLORS.primary.text};
      }
    `}

    ${disabled &&
    css`
      pointer-events: none;
      opacity: 0;
    `}
  `,
);

export const Chevron = styled(ChevronLeft)<SidebarWrapperProps>(
  ({ open }) => css`
    transition: 0.3s ease-out;
    transform: ${open && 'rotate(180deg)'};
  `,
);

export const Header = styled(Box)`
  position: absolute;
  top: 0;
  right: 0;
  width: ${iframeWidth};
  background: ${COLORS.background.main};
  height: ${SIZES.spacing(7)};
`;
